import { Modal, ModalProps } from "antd"
import { useTranslation } from "react-i18next"
import { useDeleteAccident } from "./queries"
import { useEventId, usePresenceId } from "pages/events"
import { useExecutionMember } from "../queries"

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}

const DeleteModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const eventId = useEventId()
  const presenceId = usePresenceId()
  const member = useExecutionMember(eventId!, presenceId!)
  const { mutate, isLoading } = useDeleteAccident(
    eventId!,
    member.data?.member_id!,
    props.data!,
    {
      meta: {
        type: "delete",
        context: "male",
        entity: t("accidents.accident"),
      },
    }
  )
  const onConfirm = () => {
    mutate(undefined, {
      onSuccess() {
        props.onClose()
      },
    })
  }
  return (
    <Modal
      okType="danger"
      okText={t("global.delete")}
      onCancel={props.onClose}
      onOk={onConfirm}
      confirmLoading={isLoading || member.isLoading}
      cancelText={t("global.cancel")}
      {...props}
    >
      <p style={{ marginTop: "var(--size-6)" }}>
        {t("global.delete_confirmation")}
      </p>
    </Modal>
  )
}

export default DeleteModal
